import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import classnames from 'classnames';

import {ChevronRightIcon, PlusThinIcon} from '../../icon';
import {ArchiveRegularIcon} from '../../icon/svg/archive-regular-icon';
import {Stack} from '../../layout/stack/stack';
import {LoadingPage} from '../../loading-page/loading-page';
import {LegacySetupTableWrapper} from '../../table/legacy-setup-table-wrapper';

import styles from './sidebar-section.module.css';

export type SidebarSectionLink = {
    label: string | React.ReactNode;
    isActive?: boolean;
    count?: number;
    type?: 'manage' | 'create' | 'archived' | 'default';
    to?: string;
    onClick?: () => void;
};

type Props = {
    title: string | React.ReactNode;
    links: SidebarSectionLink[];
    isLoading?: boolean;
};

export function SidebarSection(props: Props) {
    const {links} = props;

    return (
        <LegacySetupTableWrapper title={props.title}>
            <div className={styles['links-list']}>
                {links.map((link) => {
                    const {type = 'default'} = link;
                    const LinkWrapper = link.onClick ? 'button' : RoutedLink;
                    const href = link.to || '#';
                    const onClick = link.onClick ? link.onClick : undefined;

                    return (
                        // @ts-expect-error
                        <LinkWrapper
                            // @ts-expect-error
                            as={LinkWrapper}
                            to={href}
                            key={link.to}
                            onClick={onClick}
                            preventUnderline={true}
                            className={classnames({
                                [styles['link-content']]: true,
                                [styles['link-content--active']]: link.isActive,
                                [styles['link-content--blue']]:
                                    type === 'manage' || type === 'create',
                                [styles['link-content--archived']]: type === 'archived',
                            })}
                        >
                            <Stack
                                isHorizontal={true}
                                isFullWidth={true}
                                spacing={4}
                                justifyContent='space-between'
                                alignItems='center'
                            >
                                {type === 'create' && (
                                    <PlusThinIcon
                                        wrapWithDiv={false}
                                        className='flex-shrink'
                                        size={9}
                                    />
                                )}
                                {type === 'archived' && (
                                    <ArchiveRegularIcon
                                        wrapWithDiv={false}
                                        className='flex-shrink'
                                        size={13}
                                    />
                                )}
                                <div className='flex-grow'>{link.label}</div>
                                {typeof link.count === 'number' && <div>{link.count}</div>}
                                {(type === 'default' || type === 'archived') && (
                                    <div className={styles['chevron-container']}>
                                        <ChevronRightIcon size={13} />
                                    </div>
                                )}
                            </Stack>
                        </LinkWrapper>
                    );
                })}
                {props.isLoading && (
                    <div className={styles['loading-container']}>
                        <LoadingPage padding={12} />
                    </div>
                )}
            </div>
        </LegacySetupTableWrapper>
    );
}
